import { Pipe, PipeTransform } from '@angular/core';

import { HOS_VIOLATIONS } from '@lib/hos-violations';

@Pipe({ name: 'hosViolation' })
export class HosViolationPipe implements PipeTransform {
  public transform(violation: string): string {
    if (HOS_VIOLATIONS[violation] != null) {
      return HOS_VIOLATIONS[violation];
    } else {
      return violation;
    }
  }
}
